import { render, staticRenderFns } from "./Text.vue?vue&type=template&id=c85bdd4a&scoped=true"
import script from "./Text.vue?vue&type=script&lang=js"
export * from "./Text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85bdd4a",
  null
  
)

export default component.exports